import { Eyebrow, Icon, Section } from '@ui/library';
import type { Interests as InterestsData } from '@lib/schemas/site';

export interface InterestsProps {
  interests: InterestsData;
}

export function Interests({ interests }: InterestsProps) {
  return (
    <Section id="interests" tight>
      <div className="interests__grid">
        <div className="interests__copy reveal">
          <Eyebrow magenta>{interests.eyebrow}</Eyebrow>
          <h2 style={{ marginTop: 10 }}>{interests.headline}</h2>
          <p>{interests.body}</p>
        </div>
        <div className="tagcloud reveal">
          {interests.tags.map(([iconName, label]) => (
            <span className="itag" key={label}>
              <Icon name={iconName} size={17} />
              {label}
            </span>
          ))}
        </div>
      </div>
    </Section>
  );
}
